import "core-js/modules/es.array.map";
import HintBubble from "web/react/components/hint-bubble/hint-bubble";
import PropTypes from "prop-types";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./product-area-promos.css";

function ProductAreaPromo(_ref) {
  var promotion = _ref.promotion;

  if (!promotion) {
    return null;
  }

  var message = promotion.message,
      url = promotion.url,
      tcs = promotion.tcs;
  message = React.createElement("span", {
    className: styles.promoText,
    dangerouslySetInnerHTML: {
      __html: message
    }
  });
  var promoText;

  if (url) {
    promoText = React.createElement("a", {
      href: url
    }, message);
  } else {
    promoText = message;
  }

  tcs = tcs.map(function (_ref2) {
    var message = _ref2.message,
        url = _ref2.url;
    return React.createElement("a", {
      href: url,
      key: url
    }, message);
  });
  var tcsPopup = React.createElement("div", {
    className: styles.promoTCs
  }, tcs);
  return React.createElement("div", {
    className: styles.promoArea
  }, React.createElement(SVGIcon, {
    name: "tag",
    className: styles.promoIcon
  }), promoText, React.createElement(HintBubble, {
    tooltipText: tcsPopup,
    className: styles.promoTCsIcon
  }));
}

var PromoPropType = PropTypes.shape({
  message: PropTypes.string.isRequired,
  url: PropTypes.string,
  tcs: PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })).isRequired
});
ProductAreaPromo.propTypes = {
  promotion: PromoPropType
};
export default ProductAreaPromo;